import { inject, injectable } from 'inversify';
import { CONTRACTS, FetchServiceContract } from '@/core/contracts';
import { ContextsState } from '@/store';
import { IContext } from './dto';
import { IApiService, ContextPart } from './';

@injectable()
export class ApiService
    implements IApiService {

    private readonly fetchService: FetchServiceContract;

    constructor(
        @inject(CONTRACTS.FetchService) fetchService: FetchServiceContract
    ) {
        if (!fetchService) { throw new Error('fetchService is not set'); }

        this.fetchService = fetchService;
    }

    public async getContextPart(part: ContextPart): Promise<IContext> {
        const contextId = ContextsState.currentContextId;
        if (!contextId) { throw new Error('Invalid context identifier'); }

        const url = `/files/contexts/${contextId}/${part}`;
        const result = await this.fetchService.get<IContext>(url);

        return result;
    }

    public async postContext(context: IContext): Promise<void> {
        const contextId = ContextsState.currentContextId;
        if (!contextId) { throw new Error('Invalid context identifier'); }

        const url = `/files/contexts/${contextId}?ignoreWarnings=true`;
        const value = JSON.stringify(context);

        await this.fetchService.post(url, value);
    }

}
